// Hackathons and builder events, newest first. `link` is optional (e.g. a
// Devfolio/demo/repo link) — add it and it'll render as "View →".

export const hackathons = [
  {
    date: "2025",
    event: "Base Builders Grant",
    role: "Grant Recipient",
    techStack: "",
    link: "",
  },
  {
    date: "2025",
    event: "Morph's Consumer Buildathon",
    role: "Full Stack Web3 Developer",
    techStack: "Solidity, Core, Pyth",
    link: "",
  },
  {
    date: "2025",
    event: "Core Hacker House India",
    role: "Full Stack Web3 Developer",
    techStack: "Solidity, Core, Pyth",
    link: "",
  },
  {
    date: "2025",
    event: "Safe Agentathon",
    role: "Full Stack Web3 Developer",
    techStack: "Next.js, Story Protocol, OpenAI SDK",
    link: "",
  },
  {
    date: "2024",
    event: "ETHMumbai",
    role: "Full Stack Developer",
    techStack: "Next.js, Tailwind CSS, Fuel API, Sway",
    link: "",
  },
];
